export const findFolderPathByPageId = (items = [], pageId, folderPath = []) => {
    for (const item of items) {
        if (item?.type === "page" && item.id === pageId) {
            return folderPath;
        }

        if (Array.isArray(item?.children) && item.children.length > 0) {
            const nextFolderPath = item.type === "folder"
                ? [...folderPath, item.id]
                : folderPath;
            const result = findFolderPathByPageId(item.children, pageId, nextFolderPath);

            if (result) {
                return result;
            }
        }
    }

    return null;
};
